import React from 'react';
import VideoSource from "../video/BG_Video_Mist.mp4";

class Homepage extends React.Component {

  render() {
    return (
        <div className="homecontent">
        <div className="Container" >
            <video
              preload="auto"
              autoPlay="autoplay"
              playsInline loop="loop"
              muted className="Video" >
              <source src={VideoSource} type="video/mp4" />
                Your browser does not support the video tag.

              </video>
              </div>
      </div>
    );
  }
}

export default Homepage;
